import { useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import styles from '../../../assets/jss/LogBook/LogBookStyles';
import ListTable from "./ListTable/ListTable";
import GridTable from './GridTable/GridTable';
import GridViewSharpIcon from '@mui/icons-material/GridViewSharp';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import FilterComponent from "./FilterComponent";
const useStyles = makeStyles(styles);

const LogBook = (props) => {
    const classes = useStyles();
    const [tabControl, setTabControl] = useState(1);
    const [filterChoice, setFilterChoice] = useState(3);

    const listTableClicked = () => {
        setTabControl(2);
    };
    const gridTableClicked = () => {
        setTabControl(1);
    };
    const chooseFilter = (value) => {
        setFilterChoice(value);
    };
    return (
        <div
            style={{
                background: "linear-gradient(180.06deg, #FFFFFF 0.61%, #F4F4F4 17.88%, #F4F4F4 41.75%)",
                width: '100%', height: '100%',paddingTop:'25px'
            }}
        >
            <Grid container justifyContent='space-between' padding='20px 6px'>
                <Grid item xs={10}>
                    <FilterComponent filterChoice={chooseFilter}  patientId={props?.patientId}/>
                </Grid>
                <Grid
                    item
                    xs={2}
                    display='flex'
                    direction='row-reverse'
                    alignItems='center'
                >
                    <Grid display='flex' alignItems='center' onClick={gridTableClicked} item justifyContent='left' padding='0 10px'>
                        <span
                            className={` ${tabControl === 1 ? classes.iconLogSelected : classes.iconLogNotSelected
                            } ${classes.iconLog}`}
                        >
                            <GridViewSharpIcon className={classes.iconGrid} />
                        </span>
                    </Grid>
                    <Grid display='flex' alignItems='center' item onClick={listTableClicked} justifyContent='left'
                    >
                        <span
                            className={`${tabControl === 2 ? classes.iconLogSelected : classes.iconLogNotSelected
                            } ${classes.iconLog}`}
                        >
                            <MenuRoundedIcon className={classes.iconGrid} />
                        </span>
                    </Grid>
                </Grid>
            </Grid>
            {tabControl === 1 ? (
                <GridTable filterChoice={filterChoice} sharingReport={props.sharingReport} patientId={props?.patientId} />
            ) : (
                <ListTable filterChoice={filterChoice} sharingReport={props.sharingReport} patientId={props?.patientId}/>
            )}
        </div>
    );
};
export default LogBook;